import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import { getCurrentEmployeeFromState } from "app/app.selectors";
import EmployeeRolesBasePage from "features/components/EmployeeRolesBasePage";

class MyPageRolesContainer extends PureComponent {
  render() {
    const { currentEmployeeId, breadcrumb, path, Icon } = this.props;

    return (
      <EmployeeRolesBasePage
        path={path}
        title={breadcrumb}
        employeeId={currentEmployeeId}
        Icon={Icon}
      />
    );
  }
}

export default compose(
  connect(state => ({
    currentEmployeeId: getCurrentEmployeeFromState(state).get("employeeId"),
  })),
)(MyPageRolesContainer);
